export const faqItems = [
  {
    question: '挣扎吧亚当君是什么类型的游戏？',
    answer: '挣扎吧亚当君是一款沉浸式互动叙事体验作品，结合了视觉小说、选择导向剧情和心理探索元素。玩家将扮演主角亚当君，通过一系列关键选择推动剧情发展，体验不同结局。游戏采用精美的插画风格画面和原创配乐，打造极具沉浸感的叙事体验。'
  },
  {
    question: '游戏有多少种结局？',
    answer: '游戏目前包含7条主要剧情线的15个不同结局，外加3个隐藏结局。每个结局都提供了独特的叙事视角和情感体验，玩家的每一个选择都可能导向完全不同的故事走向。我们建议多次游玩以体验所有可能性。'
  },
  {
    question: '支持哪些平台？',
    answer: '挣扎吧亚当君目前支持PC（Windows/macOS）、iOS和Android平台。PC版本在Steam平台发售，移动版本可在App Store和各大安卓应用商店下载。所有平台之间不支持跨平台存档同步。'
  },
  {
    question: '游戏时长大概多久？',
    answer: '单条剧情线的通关时间约为6-8小时。若要体验全部结局和收集所有记忆碎片，总游戏时长约为30-40小时。游戏设有存档功能，你可以随时保存进度并在方便的时候继续游玩。'
  },
  {
    question: '游戏是否有年龄限制？',
    answer: '挣扎吧亚当君建议16岁以上玩家体验。游戏包含一些较为深沉的主题探讨和情感冲突场景，但不包含血腥暴力或不适内容。我们建议家长在了解游戏内容后自行判断是否适合年轻玩家。'
  },
  {
    question: '如何获取最新的游戏更新和资讯？',
    answer: '你可以关注我们的官方社交媒体账号获取最新动态，也可以订阅本站的新闻通讯。我们会在每次重大更新前通过邮件向订阅用户发送通知，确保你不会错过任何精彩内容。'
  },
  {
    question: '游戏支持哪些语言？',
    answer: '目前游戏支持简体中文、繁体中文、英语和日语四种语言。更多语言的本地化工作正在进行中，具体上线时间请关注官方公告。'
  }
];

export const testimonials = [
  {
    id: 1,
    name: '游戏玩家小林',
    role: '资深互动叙事爱好者',
    content: '我玩过很多互动叙事类游戏，但挣扎吧亚当君是第一款让我在一周目结束后立刻开始二周目的作品。每个选择都蕴含着深刻的意义，这不是简单的分支选项，而是对人性、命运和自由的真正探索。强烈推荐给每一位热爱故事的朋友。',
    rating: 5,
    date: '2026-06-15'
  },
  {
    id: 2,
    name: '阿哲的游戏笔记',
    role: '游戏评测博主',
    content: '作为评测过上百款独立游戏的博主，挣扎吧亚当君给我留下了极为深刻的印象。它在叙事深度和互动设计上达到了令人惊叹的高度。音乐和美术风格与主题完美契合，共同营造出一种独特的情感张力。年度最佳独立叙事游戏的有力竞争者。',
    rating: 5,
    date: '2026-05-28'
  },
  {
    id: 3,
    name: '夜雨声烦',
    role: '资深玩家',
    content: '一周目打出了最坏的结局，整个人沉默了很久。不是因为游戏不好，恰恰相反，是因为它太过真实。亚当君的每一次挣扎都像是在照镜子，让我看到了自己在生活中面对选择时的犹豫和恐惧。这不仅仅是一个游戏，更是一面镜子。',
    rating: 5,
    date: '2026-05-10'
  },
  {
    id: 4,
    name: '星之所在',
    role: '剧情向游戏玩家',
    content: '画面精美，音乐动人，剧情扣人心弦——挣扎吧亚当君完美诠释了什么叫做「第九艺术」。特别要夸一下中文本地化团队的用心，翻译质量无可挑剔，还加入了许多只有中文玩家才能体会到的文化细节。',
    rating: 5,
    date: '2026-04-22'
  }
];

export const brandStory = {
  title: '关于挣扎吧亚当君',
  subtitle: '在命运的洪流中，每一个选择都值得被尊重',
  sections: [
    {
      title: '品牌起源',
      content: '挣扎吧亚当君诞生于2024年的一个深夜。制作人Adam在一场关于「自由意志」的哲学讨论后，萌生了创作一部能够让玩家真正感受到选择重量的互动叙事作品的想法。经过两年的精心打磨，这个项目从一个模糊的创意成长为一部完整的作品。我们的核心理念始终如一：每一个选择都有意义，每一段挣扎都值得被看见。'
    },
    {
      title: '创作理念',
      content: '我们相信，最好的故事不是被讲述的，而是被体验的。在挣扎吧亚当君中，我们不希望玩家只是被动地观看一个故事，而是希望他们能够真正地「活」在故事之中——感受角色的喜怒哀乐，承担选择的后果，体验命运的起伏。这种沉浸式的叙事方式，是我们对互动叙事边界的探索和突破。'
    },
    {
      title: '核心团队',
      content: '挣扎吧亚当君的制作团队由一群热爱叙事艺术的创作者组成。核心成员来自游戏开发、文学创作、影视编剧等不同领域，多元的背景为作品注入了丰富的创意视角。我们虽然是一个小型独立团队，但每一个人都怀着对作品的热爱和对品质的追求。'
    }
  ]
};